function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-1df7fa56\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?indentedSyntax!residential/sass/result-insurer.scss")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PartialInsurer.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1df7fa56\",\"hasScoped\":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PartialInsurer.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1df7fa56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/enterprise/modules/Result/PartialInsurer.vue
// module id = 321
// module chunks = 0